// extracted by mini-css-extract-plugin
module.exports = {"view":"chronology_view_1FL0_","list":"chronology_list_2_mFG","item":"chronology_item_1v1jS","year":"chronology_year_2CNRp","image":"chronology_image_3NqxC"};